<div class="form-item-label-section" [uiTooltipTitle]="labelTooltip" [uiTooltipTrigger]="labelTooltip ? 'hover' : null" uiTooltipPlacement="left" ui-tooltip>
  <label [attr.for]="controlId" [id]="id">{{ labelText }}</label>
  <span class="required-star" *ngIf="required" aria-hidden="true">*</span>
</div>
